import React, { useState, useEffect } from 'react'
import { Grid, Box, Checkbox, Button, Typography } from "@mui/material"
import { styled } from '@mui/material/styles'
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import * as actions from "../../../containers/Releases/CreateReleases/actions";
import { toastError, toastSuccess } from '../../../utils';
import { Link } from 'react-router-dom';

const StyledButton = styled(Button)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
    fontSize: '1rem',
    fontWeight: 600,
    height: 48,
    minWidth: 160,
    borderRadius: '12px',
    color: "white",
    textTransform: 'none',
    boxShadow: '0 4px 12px rgba(26, 115, 232, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
        boxShadow: '0 6px 20px rgba(26, 115, 232, 0.4)',
        transform: 'translateY(-2px)',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
        height: 44,
        minWidth: 140,
        width: '100%',
        maxWidth: '300px',
    },
}));

const PlatformCard = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    padding: '28px',
    marginBottom: '24px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
    border: '2px solid rgba(26, 115, 232, 0.15)',
    transition: 'all 0.3s ease',
    '&:hover': {
        boxShadow: '0 8px 28px rgba(26, 115, 232, 0.2)',
        borderColor: 'rgba(26, 115, 232, 0.3)',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '16px',
        borderRadius: '12px',
    },
}));

const PlatformHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px',
    paddingBottom: '16px',
    borderBottom: '2px solid rgba(26, 115, 232, 0.1)',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        gap: '12px',
        marginBottom: '16px',
        paddingBottom: '12px',
    },
}));

const PlatformTitle = styled(Typography)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#202124',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.1rem',
        gap: '6px',
    },
}));

const PlatformCount = styled('span')(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '1rem',
    fontWeight: 600,
    color: '#5f6368',
    background: 'rgba(26, 115, 232, 0.1)',
    padding: '4px 12px',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.85rem',
        padding: '3px 10px',
    },
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    color: '#5f6368',
    '&.Mui-checked': {
        color: '#1a73e8',
    },
    '&.Mui-disabled': {
        color: '#00bfa5 !important',
    },
}));

const PlatformItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    borderRadius: '12px',
    background: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    transition: 'all 0.2s ease',
    minHeight: '56px',
    '&:hover': {
        background: 'rgba(26, 115, 232, 0.04)',
        borderColor: 'rgba(26, 115, 232, 0.2)',
        transform: 'translateX(4px)',
    },
    [theme.breakpoints.down('md')]: {
        gap: '10px',
        padding: '10px',
        minHeight: '52px',
    },
    [theme.breakpoints.down('sm')]: {
        gap: '8px',
        padding: '8px',
        minHeight: '48px',
    },
}));

const PlatformName = styled(Typography)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#202124',
    flex: 1,
    wordBreak: 'break-word',
    lineHeight: 1.3,
    [theme.breakpoints.down('md')]: {
        fontSize: '0.9rem',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.85rem',
    },
}));

const InfoText = styled(Typography)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.9rem',
    fontWeight: 500,
    color: '#5f6368',
    '& a': {
        color: '#1a73e8',
        textDecoration: 'none',
        fontWeight: 600,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '0.85rem',
    },
}));

function Platform(props) {

    const { platformLogo = [], setStepsDone, setDisableTab, stepsDone, disableTab, releaseID, handleTabChange, setPlatform, platform } = props;

    const [platfromVerify, setPlatfromVerify] = useState({
        caller_tune: false,
        destribute_music: false
    })

    useEffect(() => {
        setPlatformVerification()
    }, [])

    const setPlatformVerification = () => {
        props.setLoader(true)
        actions.getSubmissionDataChecks(releaseID).then(res => {
            let obj = { ...platfromVerify }
            if (res.body && res.body.caller_tune && res.body.caller_tune === 'Yes') {
                obj.caller_tune = true
            }
            if (res.body && res.body.destribute_music && res.body.destribute_music === 'Yes') {
                obj.destribute_music = true
            }
            setPlatfromVerify(obj)
            setTimeout(() => {
                props.setLoader(false)
            }, [2000])
            setPlatform({ crbt: obj.caller_tune ? 'yes' : 'no', video_platforms: obj.destribute_music ? 'yes' : 'no' })
        }).catch((err) => {
            props.setLoader(false)
            toastError(err.message)
        })
    }

    const onSubmit = () => {
        props.setLoader(true)
        actions.checkboxCrbtVideoPlatforms(platform).then(res => {
            props.setLoader(false)
            toastSuccess(res.message)
            setStepsDone({ ...stepsDone, third: true })
            setDisableTab({ ...disableTab, fourth: false })
            handleTabChange({}, 4)
        }).catch(err => {
            props.setLoader(false)
            toastError(err.message)
        })
    }

    let audioLogo = []
    let crbtLogo = []
    let videoPlatformLogo = []

    platformLogo.forEach((item) => {
        if (item.type === '1') {
            audioLogo.push({ ...item, checked: true })
        } else if (item.type === '2') {
            crbtLogo.push({ ...item, checked: platform.crbt === 'yes' })
        } else {
            videoPlatformLogo.push({ ...item, checked: platform.video_platforms === 'yes' })
        }
    })

    const handleChange = ({ target: { name = '', checked } }) => {
        if (name === 'crbt') {
            if (!platfromVerify.caller_tune) {
                return toastError('Please set caller tune first.')
            }
            setPlatform({ ...platform, crbt: checked ? 'yes' : 'no' })
        } else {
            if (!platfromVerify.destribute_music) {
                return toastError('Provide Music Video details first')
            }
            setPlatform({ ...platform, video_platforms: checked ? 'yes' : 'no' })

        }
    }

    return (
        <Box sx={{ minHeight: '400px' }}>
            <Grid container spacing={3}>
                {/* Audio Platforms */}
                <Grid item xs={12}>
                    <PlatformCard>
                        <PlatformHeader>
                            <StyledCheckbox
                                checked={true}
                                disabled
                                icon={<CheckCircleIcon />}
                                checkedIcon={<CheckCircleIcon />}
                            />
                            <PlatformTitle>
                                Audio Streaming <PlatformCount>190+ Platforms</PlatformCount>
                            </PlatformTitle>
                        </PlatformHeader>

                        <InfoText sx={{ mb: 3 }}>
                            For delivering content to only certain stores/services, please create a <Link to="/tickets" target="_blank">ticket</Link>.
                        </InfoText>

                        <Grid container spacing={2}>
                            {audioLogo.map((item, key) => (
                                <Grid key={key} item xs={12} sm={6} md={4} lg={3}>
                                    <PlatformItem>
                                        <StyledCheckbox
                                            checked={item.checked}
                                            disabled
                                            size="small"
                                        />
                                        <Box
                                            component="img"
                                            src={item.logo}
                                            alt={item.name}
                                            sx={{
                                                height: { xs: '28px', sm: '30px', md: '32px' },
                                                width: 'auto',
                                                maxWidth: { xs: '40px', sm: '50px', md: '60px' },
                                                objectFit: 'contain',
                                                flexShrink: 0,
                                            }}
                                        />
                                        <PlatformName>{item.name}</PlatformName>
                                    </PlatformItem>
                                </Grid>
                            ))}
                        </Grid>
                    </PlatformCard>
                </Grid>

                {/* CRBT Platforms */}
                <Grid item xs={12}>
                    <PlatformCard>
                        <PlatformHeader>
                            <StyledCheckbox
                                checked={platform.crbt === 'yes'}
                                name="crbt"
                                onChange={handleChange}
                            />
                            <PlatformTitle>
                                CRBT (Caller Ringback Tone) <PlatformCount>4+ Platforms</PlatformCount>
                            </PlatformTitle>
                        </PlatformHeader>

                        <Grid container spacing={2}>
                            {crbtLogo.map((item, key) => (
                                <Grid key={key} item xs={12} sm={6} md={4} lg={3}>
                                    <PlatformItem>
                                        <StyledCheckbox
                                            checked={item.checked}
                                            name="crbt"
                                            onChange={handleChange}
                                            size="small"
                                        />
                                        <Box
                                            component="img"
                                            src={item.logo}
                                            alt={item.name}
                                            sx={{
                                                height: { xs: '28px', sm: '30px', md: '32px' },
                                                width: 'auto',
                                                maxWidth: { xs: '40px', sm: '50px', md: '60px' },
                                                objectFit: 'contain',
                                                flexShrink: 0,
                                            }}
                                        />
                                        <PlatformName>{item.name}</PlatformName>
                                    </PlatformItem>
                                </Grid>
                            ))}
                        </Grid>
                    </PlatformCard>
                </Grid>

                {/* Video Platforms */}
                <Grid item xs={12}>
                    <PlatformCard>
                        <PlatformHeader>
                            <StyledCheckbox
                                checked={platform.video_platforms === 'yes'}
                                name="video"
                                onChange={handleChange}
                            />
                            <PlatformTitle>
                                Video Platforms <PlatformCount>8+ Platforms</PlatformCount>
                            </PlatformTitle>
                        </PlatformHeader>

                        <Grid container spacing={2}>
                            {videoPlatformLogo.map((item, key) => (
                                <Grid key={key} item xs={12} sm={6} md={4} lg={3}>
                                    <PlatformItem>
                                        <StyledCheckbox
                                            checked={item.checked}
                                            name="video"
                                            onChange={handleChange}
                                            size="small"
                                        />
                                        <Box
                                            component="img"
                                            src={item.logo}
                                            alt={item.name}
                                            sx={{
                                                height: { xs: '28px', sm: '30px', md: '32px' },
                                                width: 'auto',
                                                maxWidth: { xs: '40px', sm: '50px', md: '60px' },
                                                objectFit: 'contain',
                                                flexShrink: 0,
                                            }}
                                        />
                                        <PlatformName>{item.name}</PlatformName>
                                    </PlatformItem>
                                </Grid>
                            ))}
                        </Grid>
                    </PlatformCard>
                </Grid>

                {/* Save Button */}
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="center" mt={2} mb={4}>
                        <StyledButton variant="contained" onClick={onSubmit}>
                            <SaveIcon style={{ marginRight: 8, fontSize: 18 }} />
                            Save & Continue
                        </StyledButton>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Platform
